import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomSlider from "../section/CustomSlider";
import { toast, ToastContainer } from "react-toastify";  // Import Toastify components
import "react-toastify/dist/ReactToastify.css";  // Import Toastify CSS

export default function ForgotPassword() {
    const { t } = useTranslation();
    const [phoneNumber, setPhoneNumber] = useState("");
    const [otp, setOtp] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [step, setStep] = useState(1);
    const [isOtpSent, setIsOtpSent] = useState(false);

    const handlePhoneNumberSubmit = async (e) => {
        e.preventDefault();
        setIsOtpSent(true);
        setStep(2);
    };

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        if (otp === "123456") {
            setStep(3);
        } else {
            alert("Incorrect OTP. Please try again.");
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        if (newPassword !== confirmPassword) {
            alert("Passwords do not match.");
        } else {
            // Show toast notification on successful password reset
            toast.success(t("Password successfully reset!"), {
                position: "top-left",  // Toast position
                autoClose: 2000,  // Set auto-close to 2000ms
            });
            // After showing the toast, you can proceed with any other logic, like redirecting or clearing the fields
        }
    };

    return (
        <>
            {/* Toast Container for displaying the toast messages */}
            <ToastContainer />

            <section className="relative h-[100vh]">
                <div className="container h-full flex justify-between items-center">
                    <div className="w-[45%] flex flex-col gap-[40px]">
                        <div>
                            <img className="w-[150px]" src={require("../../assets/logo/logo.svg").default} alt="" />
                        </div>
                        <div className="flex flex-col text-[#09778E] font-bold text-[30px]">
                            <div>{t("Forgot your password?")}</div>
                        </div>
                        <div>
                            <CustomSlider />
                        </div>
                    </div>
                    <div className="w-[5%]">
                        <img className="h-[650px]" src={require("../../assets/icons/rigister-line.svg").default} alt="" />
                    </div>
                    <div className="w-[45%] flex flex-col justify-between gap-[50px]">
                        <div className="flex items-center text-center flex-col gap-[8px] justify-center">
                            <div className="flex flex-col text-[#09778E] font-bold text-[30px]">{t("Reset Your Password")}</div>
                            <div className="flex items-center gap-[12px]">
                                <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                                <div className="text-[#5D5A6F] flex items-center gap-[5px]">
                                    {t("Already have an account?")} <Link to={"/login"} className="text-[#09758b]">{t("Login")}</Link>
                                </div>
                                <span className="w-[30px] h-[2px] bg-[#5D5A6F] flex rounded-full"></span>
                            </div>
                        </div>
                        {step === 1 && (
                            <form onSubmit={handlePhoneNumberSubmit}>
                                <div className="flex flex-col gap-[25px]">
                                    <div className="flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Phone Number")}</label>
                                        <input
                                            type="text"
                                            className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none"
                                            placeholder={t("Your phone number")}
                                            value={phoneNumber}
                                            onChange={(e) => setPhoneNumber(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <button className="bg-[#A31D1C] p-3 font-bold text-white capitalize rounded-md" type="submit">
                                        {t("Send OTP")}
                                    </button>
                                </div>
                            </form>
                        )}
                        {step === 2 && isOtpSent && (
                            <form onSubmit={handleOtpSubmit}>
                                <div className="flex flex-col gap-[25px]">
                                    <div className="flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Enter OTP Sent to Phone")}</label>
                                        <input
                                            type="text"
                                            className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none"
                                            placeholder={t("Enter OTP")}
                                            value={otp}
                                            onChange={(e) => setOtp(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <button className="bg-[#A31D1C] p-3 font-bold text-white capitalize rounded-md" type="submit">
                                        {t("Verify OTP")}
                                    </button>
                                </div>
                            </form>
                        )}
                        {step === 3 && (
                            <form onSubmit={handlePasswordSubmit}>
                                <div className="flex flex-col gap-[25px]">
                                    <div className="flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("New Password")}</label>
                                        <input
                                            type="password"
                                            className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none"
                                            placeholder={t("New Password")}
                                            value={newPassword}
                                            onChange={(e) => setNewPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <div className="flex flex-col gap-[5px]">
                                        <label className="text-[#09778E] font-bold">{t("Confirm Password")}</label>
                                        <input
                                            type="password"
                                            className="p-3 rounded-md bg-white border-2 border-[#09778e] outline-none"
                                            placeholder={t("Confirm Password")}
                                            value={confirmPassword}
                                            onChange={(e) => setConfirmPassword(e.target.value)}
                                            required
                                        />
                                    </div>
                                    <button className="bg-[#A31D1C] p-3 font-bold text-white capitalize rounded-md" type="submit">
                                        {t("Reset Password")}
                                    </button>
                                </div>
                            </form>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}
